export const getAllShiftsWorkedTimeSpan = (daysInRole, hoursInRole) => {
  if (!daysInRole) {
    return `${hoursInRole} hour${hoursInRole === 1 ? '' : 's'}`;
  }
  if (daysInRole < 365) {
    const month = (daysInRole / 30.44).toFixed(0);
    return `${month} month${month === '1' ? '' : 's'}`;
  } else {
    const years = (daysInRole / 365).toFixed(0);
    return `${years}+ year${years === '1' ? '' : 's'}`;
  }
};

export const getHoursInRole = roles => {
  return roles
    ?.filter(role => role.is_role_match)
    .map(role => role.hours_in_role)
    .reduce((partialSum, a) => partialSum + a, 0);
};

export const getHoursInFunction = roles => {
  return roles
    ?.filter(role => role.is_function_match)
    .map(role => role.hours_in_role)
    .reduce((partialSum, a) => partialSum + a, 0);
};

export const getDaysInRole = roles => {
  return roles
    ?.filter(role => role.is_role_match)
    .map(role => role.days_in_role)
    .reduce((partialSum, a) => partialSum + a, 0);
};

export const getDaysInFunction = roles => {
  return roles
    ?.filter(role => role.is_function_match)
    .map(role => role.days_in_role)
    .reduce((partialSum, a) => partialSum + a, 0);
};

export const getCompanyLogosFromRoles = roles => {
  const logos = roles
    ?.map(role => role.brands)
    .flat(4)
    .map(brand => brand.logo_url)
    .filter(logo => !!logo);
  return logos.splice(0, 3);
};

export const formatWorkerName = workerName => {
  const nameSplit = workerName?.split(' ');
  return nameSplit[0] + (nameSplit[1] ? ` ${nameSplit[1]?.[0]}.` : '');
};
